module.exports = __webpack_public_path__ + "static/media/laddu_cover_page.a6bff054.gif";